(function () {
  var html = document.documentElement;
  if (!document.getElementById('EnterOverlay')) html.classList.add('site-entered');
  setTimeout(function () { if (!document.getElementById('EnterOverlay')) html.classList.add('site-entered'); }, 50);

  // Scroll reveal
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }) : null;
  function initReveal(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el, i) {
      if (!io) { el.classList.add('is-visible'); return; }
      el.style.transitionDelay = (i % 4) * 80 + 'ms'; io.observe(el);
    });
  }
  initReveal();
  // Safety: never leave content hidden
  setTimeout(function () {
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-visible');
    });
  }, 2500);
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); html.classList.add('site-entered'); });

  // AJAX add to cart
  var toast = document.getElementById('CartToast'), toastTimer;
  function showToast(msg) {
    if (!toast) return;
    document.getElementById('CartToastText').textContent = msg;
    toast.classList.add('show'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3500);
  }
  var adding = false;
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ajax-add')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (adding) return; adding = true;
    var idEl = form.querySelector('[name="id"]'), qEl = form.querySelector('[name="quantity"]');
    var item = { id: parseInt(idEl.value, 10), quantity: qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1 };
    var sp = form.querySelector('[name="selling_plan"]');
    if (sp && !sp.disabled && sp.value) item.selling_plan = parseInt(sp.value, 10);
    var btn = form.querySelector('[type="submit"]'), label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'ADDING…'; }
    addItems([item])
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart'); })
      .finally(function () { adding = false; if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }, true);

  // Full system bundle: adds all 4 at once
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bundle-add]'); if (!b) return;
    e.preventDefault();
    var ids = (b.getAttribute('data-bundle-add') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
    if (!ids.length) return;
    var label = b.innerHTML; b.disabled = true; b.innerHTML = 'ADDING THE FULL SYSTEM…';
    addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }))
      .then(function () {
        var code = b.getAttribute('data-discount');
        if (code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; return; }
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) { alert((err && err.description) || 'Could not add bundle'); })
      .finally(function () { b.disabled = false; b.innerHTML = label; });
  });

  // Purchase options (subscribe / one-time)
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r.matches || !r.matches('[data-purchase] input[type="radio"]')) return;
    var box = r.closest('[data-purchase]'), sp = box.querySelector('[name="selling_plan"]');
    box.querySelectorAll('.po-option').forEach(function (o) { o.classList.toggle('active', o.contains(r)); });
    if (sp) { sp.value = r.value; sp.disabled = !r.value; }
  });

  // Cart drawer
  var drawer = document.getElementById('CartDrawer'), backdrop = document.getElementById('CartBackdrop');
  function money(c) {
    var v = (c / 100).toFixed(2), fmt = window.MOD.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(c / 100);
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return v;
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function renderDrawer(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    var total = document.getElementById('CartDrawerTotal'); if (total) total.textContent = money(cart.total_price);
    // Real Shopify discounts (automatic + codes)
    var discBox = document.getElementById('CartDrawerDiscounts'), subRow = document.getElementById('CartDrawerSubRow');
    var cartLevel = cart.cart_level_discount_applications || [];
    var lineMap = {};
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var t = (al.discount_application && al.discount_application.title) || 'Discount';
        lineMap[t] = (lineMap[t] || 0) + al.amount;
      });
    });
    var rows = cartLevel.map(function (d) { return [d.title, d.total_allocated_amount]; });
    Object.keys(lineMap).forEach(function (t) { rows.push([t, lineMap[t]]); });
    var hasDisc = rows.length > 0 || cart.total_discount > 0;
    if (discBox) discBox.innerHTML = rows.map(function (r) { return '<div class="cart-subtotal discount-line"><span>✓ ' + esc(r[0]) + '</span><span>−' + money(r[1]) + '</span></div>'; }).join('');
    if (subRow) { subRow.style.display = hasDisc ? 'flex' : 'none'; document.getElementById('CartDrawerSub').textContent = money(cart.original_total_price || cart.items_subtotal_price); }
    // Founder Stack progress (hidden once a real discount applies)
    var bp = document.getElementById('BundleProgress');
    if (bp) {
      var seen = {}, n = 0; cart.items.forEach(function (it) { if (!seen[it.product_id]) { seen[it.product_id] = 1; n++; } });
      bp.style.display = hasDisc || !cart.item_count ? 'none' : '';
      document.getElementById('BundleProgressText').textContent = n >= 4 ? 'All 4 modes in your cart' : 'Add ' + (4 - n) + ' more mode' + (4 - n > 1 ? 's' : '') + ' to unlock the Founder Stack deal';
      document.getElementById('BundleProgressBar').style.width = Math.min(100, n * 25) + '%';
    }
    var co = document.getElementById('DrawerCheckout'); if (co) co.style.display = cart.item_count ? '' : 'none';
    var box = document.getElementById('CartDrawerItems'); if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="cart-note">Your cart is empty.</p>'; return; }
    box.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '<div class="product-card-placeholder">PHOTO</div>';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line-meta">' + esc(it.variant_title) + '</div>' : '';
      var plan = it.selling_plan_allocation ? '<div class="cart-line-meta">↻ ' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
      var disc = (it.line_level_discount_allocations || []).map(function (al) { return '<div class="cart-line-disc">✓ ' + esc((al.discount_application && al.discount_application.title) || 'Discount') + '</div>'; }).join('');
      var orig = it.original_line_price > it.final_line_price ? '<s class="was">' + money(it.original_line_price) + '</s>' : '';
      return '<div class="drawer-line"><a href="' + it.url + '" class="cart-line-img">' + img + '</a><div class="cart-line-info"><a href="' + it.url + '" class="cart-line-title">' + esc(it.product_title) + '</a>' + variant + plan + disc +
        '<div class="drawer-row"><div class="drawer-qty"><button type="button" aria-label="Decrease" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
        '<div class="cart-line-total">' + orig + money(it.final_line_price) + '</div></div></div></div>';
    }).join('');
  }
  // Discount code (applies real Shopify codes to the cart)
  function applyCode(code, msgEl, reload) {
    code = (code || '').trim(); if (!code) return;
    msgEl.textContent = 'Applying…'; msgEl.className = 'discount-msg';
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var hit = codes.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) { msgEl.textContent = '✓ Code ' + hit.code + ' applied'; msgEl.className = 'discount-msg ok'; }
        else if (hit) { msgEl.textContent = 'Code ' + code + ' is not valid for this cart'; msgEl.className = 'discount-msg err'; }
        else { msgEl.textContent = 'Code saved — it will apply at checkout'; msgEl.className = 'discount-msg'; }
        if (reload) { setTimeout(function () { location.reload(); }, 700); } else renderDrawer(cart);
      })
      .catch(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + (reload ? '/cart' : location.pathname);
      });
  }
  var df = document.getElementById('DiscountForm');
  if (df) df.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); applyCode(df.discount.value, document.getElementById('DiscountMsg'), false); });
  var cpd = document.getElementById('CartPageDiscount');
  if (cpd) cpd.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); applyCode(cpd.querySelector('input').value, document.getElementById('CartPageDiscountMsg'), true); });
  function refreshCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderDrawer(c); return c; }); }
  function openDrawer() { if (!drawer) return; drawer.classList.add('open'); backdrop.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('open'); backdrop.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (window.MOD.isCartPage) return; e.preventDefault(); refreshCart().then(openDrawer); });
  });
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  var closeBtn = document.getElementById('CartClose'); if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.drawer-qty button'); if (!b) return;
    b.disabled = true;
    fetch((window.MOD.cartChangeUrl || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }) })
      .then(function (r) { return r.json(); }).then(renderDrawer);
  });

  // Mobile menu
  var mt = document.getElementById('MenuToggle'), mnb = document.getElementById('MobileNavBackdrop');
  function setMenu(open) {
    html.classList.toggle('menu-open', open);
    if (mt) mt.setAttribute('aria-expanded', open ? 'true' : 'false');
    var mn = document.getElementById('MobileNav'); if (mn) mn.setAttribute('aria-hidden', open ? 'false' : 'true');
    html.style.overflow = open ? 'hidden' : '';
  }
  if (mt) mt.addEventListener('click', function () { setMenu(!html.classList.contains('menu-open')); });
  if (mnb) mnb.addEventListener('click', function () { setMenu(false); });
  document.querySelectorAll('#MobileNav a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });

  // Flash sale countdown
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.hidden = true; return false; }
      el.hidden = false;
      el.querySelector('[data-cd-d]').textContent = pad(Math.floor(d / 864e5));
      el.querySelector('[data-cd-h]').textContent = pad(Math.floor(d / 36e5) % 24);
      el.querySelector('[data-cd-m]').textContent = pad(Math.floor(d / 6e4) % 60);
      el.querySelector('[data-cd-s]').textContent = pad(Math.floor(d / 1e3) % 60);
      return true;
    }
    if (tick()) var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
  });

  // Welcome popup
  var wp = document.getElementById('WelcomePopup');
  if (wp && !html.classList.contains('design-mode')) {
    var KEY = 'mod_welcome_seen';
    function openWp() { if (wp.dataset.open) return; wp.dataset.open = '1'; wp.hidden = false; requestAnimationFrame(function () { wp.classList.add('open'); }); try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function closeWp() { wp.classList.remove('open'); setTimeout(function () { wp.hidden = true; }, 300); }
    wp.addEventListener('click', function (e) { if (e.target === wp || (e.target.closest && e.target.closest('[data-wp-close]'))) closeWp(); });
    var seen = false; try { seen = !!localStorage.getItem(KEY); } catch (e) {}
    if (window.__modWelcomeSuccess) { wp.dataset.open = ''; openWp(); }
    else if (!seen) {
      var start = function () {
        setTimeout(openWp, (parseInt(wp.dataset.delay, 10) || 8) * 1000);
        document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) openWp(); });
        window.addEventListener('scroll', function onS() {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && window.scrollY / h > 0.45) { window.removeEventListener('scroll', onS); openWp(); }
        }, { passive: true });
      };
      if (document.getElementById('EnterOverlay')) {
        var mo = new MutationObserver(function () { if (!document.getElementById('EnterOverlay')) { mo.disconnect(); start(); } });
        mo.observe(document.body, { childList: true, subtree: true });
      } else start();
    }
  }

  // Sticky add to cart
  var sticky = document.getElementById('StickyATC');
  var mainForm = document.querySelector('.product-info form.ajax-add');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainForm);
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
      if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.thumb; main.alt = t.dataset.alt || '';
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); }); t.classList.add('active');
      });
    });
  });

  // Subscribe toggle
  document.querySelectorAll('[data-toggle]').forEach(function (tg) {
    var form = tg.closest('form'), planInput = form.querySelector('[name="selling_plan"]'), out = form.querySelector('[data-price-out]');
    tg.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        tg.querySelectorAll('button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        if (planInput) planInput.value = b.getAttribute('data-plan');
        if (planInput && !b.getAttribute('data-plan')) planInput.disabled = true; else if (planInput) planInput.disabled = false;
        if (out) out.textContent = b.getAttribute('data-price');
      });
    });
  });
})();
